import { TwilioError } from 'src/app/components/chat/services/twilio/twilio.interfaces';

export const TWILIO_PROMISE_ERROR_MESSAGES: string[] = [
  'Uncaught (in promise): Error: disconnected',
  'Uncaught (in promise): SyncError: disconnected',
  'Uncaught (in promise): Error: Twilsock: request timeout:',
  'UPSTREAM_REQUEST_TIMEOUT', // handle 1l2c twilio error without crashing of the app, just in case
];

export function isTwilioPromiseRejectionError(error: unknown): boolean {
  const isTwilioError = (error: TwilioError | unknown): error is TwilioError =>
    ['message', 'status'].every((filed: string) => filed in <TwilioError>error);

  return isTwilioError(error)
    ? containsAnyOfSubstrings(error.message, TWILIO_PROMISE_ERROR_MESSAGES) || error.status === 0
    : false;
}

export function isChunkError(error: Error, chunkErrorMessages: RegExp[]): boolean {
  return containsAnyOfRegExp(error.message, chunkErrorMessages);
}

export function containsAnyOfSubstrings(errorMessage: string, substrings: string[]): boolean {
  for (let i = 0; i !== substrings.length; i++) {
    const substring: string = substrings[i];
    if (errorMessage.indexOf(substring) !== -1) {
      return true;
    }
  }
  return false;
}

export function containsAnyOfRegExp(errorMessage: string, chunkErrorMessages: RegExp[]): boolean {
  for (let i = 0; i !== chunkErrorMessages.length; i++) {
    const chunkErrorMessage: RegExp = chunkErrorMessages[i];
    if (chunkErrorMessage.test(errorMessage)) {
      return true;
    }
  }
  return false;
}
